import { type SanityGallery, type SanityWing } from '@metmuseum/types';
import { sortAndGroupGalleries } from 'helpers/galleries';
import { useTranslations } from 'next-intl';

const DisplayGalleryAndFloor = ({
	galleries,
	wings,
}: {
	galleries?: SanityGallery[];
	wings?: SanityWing[];
}) => {
	const t = useTranslations();
	if (!galleries?.length && !wings?.length) return <></>;

	let galleryName;
	let floorName;

	// We only want to display the first gallery in the list. it could be "Gallery 123" or "Gallery 123-134"
	if (galleries?.length) {
		const sortedGalleries = sortAndGroupGalleries(galleries);
		// just get the first gallery in the first group to be a starting point
		const gallery = sortedGalleries[0][0];
		galleryName = gallery.number
			? t('welcomePage.gallery', { number: gallery.number })
			: gallery.name;
		floorName = gallery.floor?.title;
	}
	// Just get the first wing. we don't have a lot of space on the card
	else {
		const wing = wings[0];
		galleryName = wing.name;
		floorName = wing.floors?.[0]?.title;
	}

	return (
		<>
			{floorName} · {galleryName}
		</>
	);
};

export default DisplayGalleryAndFloor;
